// extracted by mini-css-extract-plugin
module.exports = {"StaticDropDown":"HeaderDropDown__StaticDropDown__z1u4"};